<script>
import { isSelectedEventGroupLocked } from "@app/store/eventGroupStore.svelte.js";
import { projectState } from "@app/store/projectStore.svelte.js";
import { commitHistory } from "@app/store/historyStore.svelte.js";
import { toast } from "@zerodevx/svelte-toast";
import * as m from "@app/paraglide/messages.js";

/** @type {{ row: any, column: any, api?: any }} */
let { row } = $props();

let isCustom = $derived(typeof row?.yPos === "number");
let current = $derived(normalizeYPos(row?.yPos));

/**
 * @param {string | number | undefined | null} value
 */
function normalizeYPos(value) {
    if (value === "start" || value === "top") return "start";
    if (value === "center" || value === "middle") return "center";
    return "end"; // default bottom (matches EventsTable default)
}

/**
 * @param {"start" | "center" | "end"} yPos
 */
function setYPos(yPos) {
    if (isSelectedEventGroupLocked()) {
        toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
        return;
    }

    const egIdx = projectState.selected;
    const eventId = row?.id;
    if (eventId == null || egIdx == null) return;

    commitHistory({
        name: "update vertical position",
        eventGroup: egIdx,
        mutate: {
            eventGroupState: (draft) => {
                const idx = draft[egIdx].events.findIndex((e) => e.id === eventId);
                if (idx < 0) return;
                draft[egIdx].events[idx].yPos = yPos;
                if (!draft[egIdx].selected.includes(idx)) {
                    draft[egIdx].selected = [idx];
                }
            },
        },
    });
}
</script>

{#if isCustom}
    <span class="custom-pos" title={String(row.yPos)}>{row.yPos}</span>
{:else}
    <div class="lcr-cell" role="group" aria-label={m.editor_table_column_v()}>
        <button
            type="button"
            class="lcr-btn"
            class:active={current === "start"}
            title="Top"
            onclick={(e) => {
                e.stopPropagation();
                setYPos("start");
            }}>T</button>
        <button
            type="button"
            class="lcr-btn"
            class:active={current === "center"}
            title="Middle"
            onclick={(e) => {
                e.stopPropagation();
                setYPos("center");
            }}>M</button>
        <button
            type="button"
            class="lcr-btn"
            class:active={current === "end"}
            title="Bottom"
            onclick={(e) => {
                e.stopPropagation();
                setYPos("end");
            }}>B</button>
    </div>
{/if}

<style>
.custom-pos {
    user-select: text;
    font-size: 0.75rem;
}
.lcr-cell {
    display: inline-flex;
    gap: 2px;
    align-items: center;
    height: 100%;
}
.lcr-btn {
    border: 1px solid transparent;
    background: transparent;
    color: inherit;
    font-size: 0.7rem;
    font-weight: 600;
    line-height: 1;
    padding: 0.15rem 0.35rem;
    border-radius: 0.25rem;
    cursor: pointer;
    min-width: 1.4rem;
}
.lcr-btn:hover {
    background: rgba(13, 110, 253, 0.15);
}
.lcr-btn.active {
    background: #0d6efd;
    color: #fff;
}
</style>
